'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 40px;\n  width: 40px;\n\n  input {\n    height: 40px;\n    width: 40px;\n    padding: 0;\n    border: 0;\n    cursor: pointer;\n\n    box-shadow: none !important;\n\n    &::-webkit-color-swatch-wrapper {\n      padding: 0;\n    }\n\n    &::-webkit-color-swatch {\n      border-radius: 20px;\n      border: 0;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1.5;\n  font-weight: bold;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 15px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('antd');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ColorPickerWrapper = _styledComponents2.default.div(_templateObject());

var ColorPickerLabelsWrapper = _styledComponents2.default.div(_templateObject2());

var ColorPickerValueLabel = _styledComponents2.default.span(_templateObject3());

var StyledColorPicker = (0, _styledComponents2.default)(_antd.Input)(_templateObject4());

function Input(props) {
  var placeholder = props.placeholder,
      onChange = props.onChange;
  return props.type === 'color' ? _react2.default.createElement(ColorPickerWrapper, null, _react2.default.createElement(StyledColorPicker, _extends({
    onChange: onChange,
    placeholder: placeholder
  }, props)), _react2.default.createElement(ColorPickerLabelsWrapper, null, _react2.default.createElement(ColorPickerValueLabel, null, props.value))) : _react2.default.createElement(_antd.Input, _extends({
    onChange: onChange,
    placeholder: placeholder
  }, props));
}

Input.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired
};
Input.defaultProps = {};
exports.default = Input;